module.exports = __webpack_public_path__ + "img/about/80243-032.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-032.png
// module id = 32
// module chunks = 0